import clsx from 'clsx'
import { Icon } from '@iconify/react'
import { Button, Dropdown } from '@pepper/ui'
import {
  NumberParam,
  StringParam,
  useQueryParam,
  withDefault,
} from 'use-query-params'

import s from './DeviceDropdown.module.css'

const devices = [
  {
    label: 'All Devices',
  },
  {
    label: 'Desktop',
    value: 'desktop',
  },
  {
    label: 'Mobile',
    value: 'mobile',
  },
]

const DeviceDropdown = () => {
  const [device, setDevice] = useQueryParam(
    'device',
    withDefault(StringParam, undefined)
  )

  const [_, setPage] = useQueryParam('page', withDefault(NumberParam, 1))

  const handleClick = (value?: string) => {
    setDevice(value)
    setPage(1)
  }

  const deviceMenu = (
    <div className={s.menu}>
      {devices.map(_device => (
        <Button
          type="text"
          key={_device.label}
          className={clsx(s.menuItem, {
            [s.active]: device === _device.value,
          })}
          onClick={() => handleClick(_device.value)}
        >
          {_device.label}
        </Button>
      ))}
    </div>
  )

  return (
    <Dropdown overlay={deviceMenu} trigger={['click']}>
      <Button
        size="large"
        icon={<Icon icon="lucide:monitor-smartphone" width={16} height={16} />}
        iconPlacement="left"
      >
        {devices.find(d => d.value === device)?.label ?? devices[0].label}
        <Icon icon="lucide:chevron-down" width={18} height={18} />
      </Button>
    </Dropdown>
  )
}

export default DeviceDropdown
